//@vendor
const React = require('react');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');

// @utilities
const { formatText } = require('core/i18n').i18n;

//@commons
const CustomMessageBox = require('components/contactCenter/customMessageBox/customMessageBox');


class CancelCardPayLaterSuccessStep extends React.Component {
    constructor(props) {
        super(props);
        this.backToCards = this.backToCards.bind(this);
    }

    backToCards() {
        this.props.history.push('/myprofile/cards');
    }
    render() {
        const title = formatText('cancelPayLater-successTitle');
        const subTitle = formatText('cancelPayLater-successSubTitle');
        const goBackButtonLabel = formatText('cancelPayLater-goBackButton').toUpperCase();

       return (
           <article className="card-activator-success">
               <CustomMessageBox
                   icon="icon-success"
                   title={title}
                   subtitle={subTitle}
                   textLink={goBackButtonLabel}
                   goBackHandler={this.backToCards}
                />
           </article>
        );
    }
}

CancelCardPayLaterSuccessStep.propTypes = {
    history: PropTypes.object.isRequired,
}

module.exports = withRouter(CancelCardPayLaterSuccessStep);

